import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import StatsCard from './StatsCard'

const Metric = styled.p`
  text-align: center;
  color: ${props => props.theme.dashboard.metric};
  font-size: 2.5rem;
  align-self: center;
`

export const AverageInspectionRating = ({ inspections, tooltipText }) => {
  const [finalAverage, setFinalAverage] = useState(0)
  useEffect(() => {
    if (inspections?.length > 0) {
      let totalScoreSum = 0
      let inspectionsWithScoresCount = 0
      inspections.forEach(inspection => {
        let score = null

        // Prioritize inspectionPercent if it's a valid number
        if (typeof inspection.inspectionPercent === 'number' && !isNaN(inspection.inspectionPercent)) {
          score = inspection.inspectionPercent
        } else if (inspection?.areas?.length > 0) {
          // Fallback to areas calculation for backward compatibility
          let letsImproveAreas = 0
          let greatAreas = 0
          inspection.areas.forEach(area => {
            if (area.rating === 1) {
              letsImproveAreas++
            } else if (area.rating === 3) {
              greatAreas++
            }
          })
          if (letsImproveAreas + greatAreas > 0) {
            score = Math.floor(
              (greatAreas / (letsImproveAreas + greatAreas)) * 100
            )
          } else {
            // If areas exist but none are rated 1 or 3, this inspection cannot be scored by this method.
            score = null
          }
        }

        if (score !== null) {
          totalScoreSum += score
          inspectionsWithScoresCount++
        }
      })
      if (inspectionsWithScoresCount > 0) {
        setFinalAverage(Math.floor(totalScoreSum / inspectionsWithScoresCount))
      } else {
        setFinalAverage(0)
      }
    } else {
      setFinalAverage(0)
    }
  }, [inspections])


  return (
    <StatsCard title={'Average Inspection Rating'} tooltipText={tooltipText}>
      <Metric>{finalAverage}%</Metric>
    </StatsCard>
  )
}
